export const DEFAULT_GRADE = 'platinum';
